export default __webpack_public_path__ + "static/media/cameroon.94702809.svg";